import BudgetsPage, { budgetsListQuery } from "@app/pages/budgets/budgets-page";
import type { budgetsPage_Query } from "@app/queries/budgetsPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/budgets")({
  loader: () =>
    loadQuery<budgetsPage_Query>(environment, budgetsListQuery, {}, { fetchPolicy: "network-only" }),
  head: () => pageHead("Budgets"),
  component: BudgetsRoute,
});

function BudgetsRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary fallback={<div className="p-6 text-red-500">Error loading budgets</div>}>
      <Suspense fallback={<div className="p-6 text-gray-500">Loading budgets…</div>}>
        <BudgetsPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
